import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { Content3DData } from './schema';
import { hasConfigured3DModel } from './schema';

export const content3DValidator: ContentValidator<Content3DData> = {
    validate(data: Content3DData): ValidationResult {
        if (!hasConfigured3DModel(data)) {
            return {
                isValid: false,
                errors: [
                    {
                        field: 'assetId',
                        message: 'Upload a 3D model (.glb / .gltf) file.',
                    },
                ],
            };
        }
        return { isValid: true, errors: [] };
    },
};
